import { PineTreeFireIcon } from './PineTreeFireIcon';

/**
 * author: Austin Andrews
 * id 707539BB-56A1-4346-B907-95DEE51799A3
 * name pine-tree-fire
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pine-tree-fire.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const WildfireIcon = PineTreeFireIcon;
export default WildfireIcon